'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import Image, { StaticImageData } from 'next/image';
import type { CSSProperties } from 'react';
import LoadingIndicator from './loading-indicator';
type PropsType = {
  src: string | StaticImageData;
  alt: string;
  fill?: boolean;
  width?: number;
  height?: number;
  sizes?: string;
  className?: string;
  priority?: boolean;
  loadingClassName?: string;
  style?: CSSProperties;
};
const LazyImage = t0 => {
  const $ = _c(18);
  const {
    src,
    alt,
    fill: t1,
    width,
    height,
    sizes,
    className,
    priority: t2,
    loadingClassName: t3,
    style
  } = t0;
  const fill = t1 === undefined ? false : t1;
  const priority = t2 === undefined ? false : t2;
  const loadingClassName = t3 === undefined ? "" : t3;
  const [loading, setLoading] = useState(true);
  let t4;
  if ($[0] !== loading || $[1] !== loadingClassName) {
    t4 = loading && <div className={`bg-muted absolute inset-0 flex items-center justify-center select-none ${loadingClassName}`}><LoadingIndicator size="small" /></div>;
    $[0] = loading;
    $[1] = loadingClassName;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const t5 = `transition-all duration-300 select-none ${className}`;
  const t6 = priority ? undefined : "lazy";
  let t7;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => setLoading(false);
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  let t8;
  if ($[4] !== alt || $[5] !== fill || $[6] !== height || $[7] !== priority || $[8] !== sizes || $[9] !== src || $[10] !== style || $[11] !== t5 || $[12] !== t6 || $[13] !== width) {
    t8 = <Image src={src} alt={alt} fill={fill} width={width} height={height} sizes={sizes} className={t5} style={style} loading={t6} priority={priority} onLoad={t7} />;
    $[4] = alt;
    $[5] = fill;
    $[6] = height;
    $[7] = priority;
    $[8] = sizes;
    $[9] = src;
    $[10] = style;
    $[11] = t5;
    $[12] = t6;
    $[13] = width;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t4 || $[16] !== t8) {
    t9 = <>{t4}{t8}</>;
    $[15] = t4;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  return t9;
};
export default LazyImage;